export const PERSONAL_INFO_SECTION = 'personal-info';
export const DOB_INFO_SECTION = 'dob-info';
export const BANK_INFO_SECTION = 'bank-info';
